import {ResourceType} from "../../definitions/types";
import {DesignServiceModel} from "../domain/designServiceModel";

/**
 * @class DesignServicesModel
 * @description Model for the design services for a product
 * Only one design service will ever be returned, but keeping symmetrical with the warranties model
 * @param {ResourceType[]} resources
 */
export class DesignServicesModel {
    private readonly _designServices: DesignServiceModel[];

    constructor(public readonly resources: ResourceType[]) {
        this._designServices = resources
            .filter(resource => resource.type === 0)
            .map(resource => new DesignServiceModel(resource));
    }

    /**
     * @method designServices
     * @description Returns the design services array of the model
     * @returns {DesignServiceModel[]}
     */
    public get designServices(): DesignServiceModel[] {
        return this._designServices;
    }
}